import React from 'react';
import { MessagesSquareIcon } from 'lucide-react';
import { collectionChecklist } from '../data/content';
import { CheckItem } from './CheckItem';
export function ProductIntro() {
  return <section className="bg-white px-4 py-6 text-center md:px-12 md:py-8" data-id="element-163" data-mp="1noo0o61xlxv3">
      <h2 className="mx-auto max-w-[620px] font-heading text-[19px] font-extrabold uppercase leading-[1.2] tracking-[-0.2px] text-navy md:text-[24px]" data-id="element-164" data-mp="1nqik1fxk1hx2">
        The complete 6-in-1 advanced AAC intervention system
      </h2>
      <p className="mt-1.5 font-heading text-[26px] font-extrabold uppercase leading-[1.1] tracking-[-0.3px] text-brand md:text-[34px]" data-id="element-165" data-mp="2lcfy914wj137">
        <MessagesSquareIcon className="mr-2 inline h-7 w-7 -translate-y-1 text-gold md:h-8 md:w-8" strokeWidth={2.5} aria-hidden data-id="element-166" data-mp="26mh4dakdqbtj" />
        Complete AAC Communication Toolkit™
      </p>
      <p className="mt-1.5 font-heading text-[11px] font-bold uppercase leading-tight tracking-[0.1em] text-goldDark md:text-[12px]" data-id="element-167" data-mp="2zamn5rrvhqqq">
        Advanced ready-to-use clinical resources for Speech-Language Pathologists
      </p>
      <p className="mx-auto mt-1 max-w-[600px] text-[13px] leading-[1.35] text-ink md:text-[14px]" data-id="element-168" data-mp="ufyf2faaspmr">
        Functional AAC • Complex Language • Self-Advocacy • Alternative Access • Real-World Participation • Clinical
        Decision-Making
      </p>
      <p className="mt-1 font-heading text-[12px] font-extrabold uppercase text-brand md:text-[13px]" data-id="element-169" data-mp="ze8bsubo7yah">
        6 Professional Volumes + 5 FREE Bonuses
      </p>

      <h3 className="mt-4 font-heading text-[15px] font-extrabold uppercase leading-tight text-navy md:text-[17px]" data-id="element-170" data-mp="1d7zna88yps8u">
        Your complete collection includes
      </h3>
      <ul className="mt-2.5 grid gap-x-6 gap-y-1 text-left text-[14px] leading-[1.35] text-ink sm:grid-cols-2 md:text-[15px]" data-id="element-171" data-mp="1n3u9tegb47gw">
        {collectionChecklist.map(item => <CheckItem key={item} data-id="element-172" data-mp="3ouxoqfx8c879">{item}</CheckItem>)}
      </ul>

      <div className="mt-4 border-t border-line pt-3" data-id="element-173" data-mp="3jwmfo7ere1q3">
        <p className="font-heading text-[18px] font-extrabold uppercase leading-tight text-navy md:text-[22px]" data-id="element-174" data-mp="3jy77vqdlp8ks">
          390 pages of specialized AAC materials
        </p>
        <p className="mx-auto mt-1 max-w-[560px] font-heading text-[12px] font-extrabold uppercase text-brand md:text-[14px]" data-id="element-175" data-mp="hi0ms5v9eq9o">
          One collection. Eleven professional resources. Multiple areas of advanced AAC practice.
        </p>
      </div>
    </section>;
}